// Chess previous-game result popup. Mirrors Rummy's RecoveryScreen
// shape — trophy/defeat/draw art, two-line title ("PREVIOUS GAME"
// caption above the big outcome word), captured-opponents subtitle,
// amount-box, Back-to-Lobby button. Hardened against the acknowledge-
// lost-in-the-network bug via the shared localStorage guard in
// `core/lib/recoveryAck.ts`.

export type ChessRecoveryKind = 'win' | 'loss' | 'draw' | 'kick';

type Props = {
  kind: ChessRecoveryKind;
  /** Payout credited (win) or forfeited (loss) / refunded (draw). */
  amount: number;
  pot: number;
  platformFee?: number;
  opponents?: Array<{ name?: string; isBot?: boolean }>;
  onAck: () => void;
};

function fmt(n: number) {
  return n.toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

export default function RecoveryScreen({
  kind, amount, pot: _pot, platformFee, opponents, onAck,
}: Props) {
  const isWin = kind === 'win';
  const iconSrc = isWin
    ? '/games/chess/Victory_Trophy.png'
    : '/games/chess/Defeat_Medal.png';

  const titleLabel = 'PREVIOUS GAME';
  const title = (() => {
    switch (kind) {
      case 'win':  return 'YOU WON!';
      case 'loss': return 'YOU LOST';
      case 'draw': return 'DRAW';
      case 'kick': return 'DISCONNECTED';
    }
  })();

  const amountLabel = (() => {
    switch (kind) {
      case 'win':  return 'Credited';
      case 'loss': return 'Bet Forfeited';
      case 'draw': return 'Refunded';
      case 'kick': return 'Bet Forfeited';
    }
  })();

  const oppNames = (opponents || []).map((o) => o?.name).filter(Boolean).join(', ');
  const subtitle = oppNames
    ? `Played vs ${oppNames}`
    : isWin ? 'Glory was yours'
    : kind === 'draw' ? 'A hard-fought tie'
    : 'Better luck next round';

  return (
    <div className="chess-result-backdrop">
      <div className="chess-result-card">
        <img
          src={iconSrc}
          alt=""
          className="chess-result-icon"
          draggable={false}
        />
        <div className="chess-result-label">{titleLabel}</div>
        <h2 className="chess-result-title">{title}</h2>
        <p className="chess-result-subtitle">{subtitle}</p>
        <div className="chess-result-amount">
          <span className="chess-result-amount-label">{amountLabel}</span>
          <span className="chess-result-amount-value">{fmt(amount)}</span>
        </div>
        {isWin && platformFee ? (
          <div className="chess-result-fee">Platform fee: {fmt(platformFee)}</div>
        ) : null}
        <button
          type="button"
          className="chess-result-btn"
          onClick={onAck}
        >
          Back to Lobby
        </button>
      </div>
    </div>
  );
}
